

/**
 * 获取当前日期
 * 格式为YYYY - MM - DD
 *
 * @returns
 */
function getNowFormatDate() {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}

/**
 * 获取一个月前的日期
 * 格式为YYYY - MM - DD
 *
 * @returns
 */
function getLastMonthDate() {
  let timestamp = Date.parse(new Date());
  timestamp = timestamp / 1000;
  let lastMonthTimeStamp = timestamp - (60 * 60 * 24 * 30);
  let lastMonthDate = timestampToTime(lastMonthTimeStamp);

  return (lastMonthDate);
}


/**
 * 时间戳转为日期
 *
 * @param {*} timestamp
 * @returns
 */
function timestampToTime(timestamp) {
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
  return Y + M + D;
}

export {
    getNowFormatDate,
    getLastMonthDate
}



//////////////////
// WEBPACK FOOTER
// ./static/js/date.js
// module id = KheU
// module chunks = 1